import React from "react";
import { Button, Typography } from "antd";
import { Link } from "react-router-dom";
import { detectionLogo } from "../../images";
import HeaderPage from "../../pages/HeaderPage";
import { BASE_AUTH_URL } from "../../App";
import getCookie, { AuthToken } from "../../components/Common/Utils";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
const { Title } = Typography;

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const login = async () => {
    try {
      window.location.href = BASE_AUTH_URL;
      if (AuthToken.isValid()) {
        navigate("/", { replace: true });
      } else {
        console.error("Login failed: Token not found or invalid");
      }
    } catch (err) {
      console.error("Connection error", err);
    }
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "220px",
          width: "600px",
          maxWidth: "650px",
          background: "rgba(0, 0, 0, 0.3)",

          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          flexDirection: "column",
        }}
      >
        <HeaderPage />
        <br />

        <div>
          <Button
            type="primary"
            style={{
              marginRight: 25,
              padding: "0px 20px 0px 20px",
            }}
            onClick={() => login()}
          >
            SIGN IN
          </Button>
          <Button type="default" style={{ padding: "0px 20px 0px 20px" }}>
            <Link to="/signup" style={{ fontSize: "16px", color: "#000" }}>
              REGISTER
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
